import { Preferences } from "../../profile/objects/preferences";
import { CANCEL_CONDITION_MODULE } from "../constants/cancelConditionConstants";
import { Column } from "../objects/column";

export const setCancelConditionPreference = (new_preferences: Preferences[], state_columns: Column[]): { order_by: string, order: 'asc' | 'desc', columns: Column[], preferences: Preferences[] } => {
    const field_name: string[] = [];
    const columns: Column[] = [];
    const preferences: Preferences[] = [];
    let order_by = '';
    let order: 'asc' | 'desc' = 'asc';
    new_preferences.map((preference: Preferences) => {
        if (preference.module === CANCEL_CONDITION_MODULE) {
            if (!field_name.includes(preference.field_name)) {
                switch (preference.field_name) {
                    case 'NAME':
                        columns.push({ label: 'name', field_name: preference.field_name, checked: preference.active, order_by: 'name', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'name' : order_by;
                        break;
                    case 'IS_APPS':
                        columns.push({ label: 'is-apps', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false });
                        break;
                    case 'IS_CMS':
                        columns.push({ label: 'is-cms', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false });
                        break;
                    case 'CREATED_DATE':
                        columns.push({ label: 'created-date', field_name: preference.field_name, checked: preference.active, order_by: 'created_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'created_date' : order_by;
                        break;
                    case 'CREATED_BY':
                        columns.push({ label: 'created-by', field_name: preference.field_name, checked: preference.active, order_by: 'creator__username', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'creator__username' : order_by;
                        break;
                    case 'MODIFIED_DATE':
                        columns.push({ label: 'modified-date', field_name: preference.field_name, checked: preference.active, order_by: 'modified_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'modified_date' : order_by;
                        break;
                    case 'MODIFIED_BY':
                        columns.push({ label: 'modified-by', field_name: preference.field_name, checked: preference.active, order_by: 'last_author__username', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'last_author__username' : order_by;
                        break;
                    default:
                        break;
                }
                preferences.push(preference);
                field_name.push(preference.field_name);
                order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : order;
            }
        }
    });
    if (columns.length !== state_columns.length) {
        state_columns.map(column => {
            let added = false;
            for (let i = 0; i < columns.length; i++) {
                if (columns[i].label === column.label) {
                    added = true;
                    break;
                }
            }
            if (!added) {
                columns.push({ ...column });
            }
        });
    }
    return { order_by, order, columns, preferences };
};
